import {
  AD_DEFAULT_HEIGHT,
  AD_DEFAULT_WIDTH,
  AD_MOBILE_HEIGHT,
  AD_MOBILE_WIDTH,
  GAPI_AD_RESPONSIVE,
} from '@app/constants';
import { ADUNIT_SIZE, type AdunitSize, type Dimensions } from '@app/types';

export function getDimensionsFromSize(size?: string | undefined): Dimensions {
  const responsive: Dimensions = {
    width: AD_DEFAULT_WIDTH,
    height: AD_DEFAULT_HEIGHT,
  };

  if (!size) {
    return responsive;
  } else if (size === GAPI_AD_RESPONSIVE) {
    return responsive;
  } else {
    const [width, height] = size.split('x');
    const fixed: Dimensions = {
      width: Number(width),
      height: Number(height),
    };
    return fixed;
  }
}

export function getSizeTypeFromSize(size?: string | null): AdunitSize {
  if (!size) {
    return ADUNIT_SIZE.RESPONSIVE;
  }
  return size === GAPI_AD_RESPONSIVE
    ? ADUNIT_SIZE.RESPONSIVE
    : ADUNIT_SIZE.FIXED;
}

export const getDefaultAdDimensions = (isMobile: boolean) => ({
  width: isMobile ? AD_MOBILE_WIDTH : AD_DEFAULT_WIDTH,
  height: isMobile ? AD_MOBILE_HEIGHT : AD_DEFAULT_HEIGHT,
});
